<template>
    <div>
        <div class="notice">
            {{ $t('please refresh your page') | capitalize }}
        </div>
        <Illustration xl image="/static/img/illustrations/ticket__purchase-maintenance.svg"/>
    </div>
</template>

<script>
    export default {
        name: 'UnderMaintenance',
    };
</script>



// WEBPACK FOOTER //
// src/app/modals/modals/UnderMaintenance.vue